import Component from '../core/Component'

export default class GiftCardCalculator extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            inputs: [],
            display: null
        }

        this.finalValue = 0
    }

    prepare() {
        this.ref.inputs.forEach((input, index) => {
            this.ref.inputs[index].addEventListener('change', ::this.changeValue)
            this.ref.inputs[index].addEventListener('input', ::this.changeValue)
            this.ref.inputs[index].addEventListener('textInput', ::this.changeValue)
        })
    }

    changeValue(event) {
        this.finalValue = 0

        this.ref.inputs.forEach((input, index) => {
            this.finalValue += input.getAttribute('data-val') * input.value
        })

        this.ref.display.innerHTML = this.finalValue
    }
}